/*
  As of April 2023, MathQuill v0.10.1 has a bug for empty text like \text{}. This bug was resolved in https://github.com/mathquill/mathquill/pull/517 but has not released yet.
  So the master branch of MathQuill is cloned and with the help of Makefile the output files are copied in vendor folder. The Package.json is renamed to -alpha.0 so it can
  be distinguished from the original package.
*/

import 'static-vendor/mathquill-0.11.0-alpha.0/mathquill.min';

const MQ = global.MathQuill.getInterface(2);
export default MQ;
